<template>
  <!-- PREHLED ZARIZENI -->
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header d-flex flex-column list-page__header layout__content__header--white">
        <CopyNotification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />

        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("LORA_ZARIZENI") }}
          </h1>
          <div class="list-page__buttons align-items-center d-flex d-sm-none">
            <RouterLink
              :to="{
                name: 'bulkImport'
              }"
              class="d-none btn btn-outline-primary d-lg-flex align-items-center justify-content-center"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-plus-orange.svg" />
              </div>
              {{ $t("hromadnyImport") }}
            </RouterLink>
            <ImportDeviceButton />
          </div>
        </div>
        <div v-if="project" class="d-flex">
          <div class="d-flex list-page__left align-items-center">
            <div
              v-if="project.projectId && project.projectId != 'undefined'"
              class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
            >
              <!--              <span v-if="suggestionLoading">-->
              <!--                <app-loader />-->
              <!--              </span>-->
              <!--div v-if="suggested != ''" class="custom-control--search__suggested"><span class="atom-tag" @click="suggested = ''">{{suggested}}</span></div-->
              <input
                id="guisearch"
                ref="searchInput"
                v-model="search"
                :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
                autofocus
                class="w-100"
                type="text"
                @keyup.enter="searchLoraDevices()"
              />

              <div v-if="search" class="atom-icon" @click="clearSearch()">
                <img src="@/assets/icons/actions/ico-close.svg" />
              </div>
              <div class="atom-icon" @click="searchLoraDevices()">
                <img src="@/assets/icons/actions/ico-search-black.svg" />
              </div>
              <div class="custom-control--search__suggestions">
                <div
                  v-for="(suggestion, index) in suggestionsArray"
                  :key="index"
                  class="custom-control--search__suggestions__item"
                  @click="setSuggestion(suggestion)"
                >
                  <span>{{ suggestion }}</span>
                </div>
              </div>
            </div>
            <div class="list-page__link d-none d-lg-flex" style="flex-shrink: 0">
              <a
                :class="{ open: this.enabledExtendedSearch }"
                class="d-flex align-items-center extended-search__toggle"
                @click="toggleExtendedSearch()"
              >
                {{ $t("pokrocilaFiltrace") }}
                <img class="" src="@/assets/icons/arrows/arr-orange-down.svg" />
              </a>
            </div>
          </div>
          <div
            v-if="project.projectId && project.projectId != 'undefined'"
            class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between"
          >
            <RouterLink
              :to="{
                name: 'bulkImport'
              }"
              class="d-none btn btn-outline-primary d-md-flex align-items-center justify-content-center"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-plus-orange.svg" />
              </div>
              {{ $t("hromadnyImport") }}
            </RouterLink>
            <ImportDeviceButton />
          </div>
        </div>

        <div class="list-page__link d-flex d-lg-none mt-md-2 justify-content-start" style="flex-shrink: 0">
          <a
            :class="{ open: this.enabledExtendedSearch }"
            class="d-flex align-items-center extended-search__toggle"
            @click="toggleExtendedSearch()"
          >
            {{ $t("pokrocilaFiltrace") }}
            <img class="" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>
        </div>

        <ExtendedSearch
          v-if="enabledExtendedSearch"
          :filter-type="filterType"
          @set-filter-data="setFilterData($event)"
        />

        <div class="mt-4">
          <div class="d-lg-flex">
            <div
              :class="{ checked: this.isSearchThroughAllProjects }"
              class="custom-control custom-control--checkbox"
              style="display: inline-block"
              @click="searchThroughAllProjects()"
            >
              <input class="custom-control-input" type="checkbox" />
            </div>
            <label>{{ $t("SEARCH_THROUGH_ALL_PROJECTS") }}</label>
          </div>
        </div>
      </div>

      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/devices/lora'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose
            :radio-slides="radioSlides"
            :show="showHelp"
            @update-show-radio-help="showRadioHelp($event)"
          />
        </div>
      </div>

      <div v-if="allDevices && allDevices.length > 0" class="layout__content__content pt-4 pt-md-5">
        <DeviceListWarningBoxes technology="lora" @set-filter="setFilterData" />
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button
            v-if="selectedRows.length > 0"
            class="btn btn-primary d-flex align-items-center"
            @click="showDropdownActions()"
          >
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <button v-else class="btn btn-primary d-flex align-items-center" disabled>
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <div
            v-if="isActionsDropdownVisible && selectedRows.length > 0"
            class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
          >
            <div class="dropdown-actions__inner">
              <div class="row">
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleAddTagsModal('editTags')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-label.svg" />
                  </div>
                  {{ $t("pridatTagy") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleChangeStatusModal('changeStatus')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                  </div>
                  {{ $t("zmenitRezim") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleRemoveTagsModal('editTags')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-label.svg" />
                  </div>
                  {{ $t("odebratTagy") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleSendMessageModal('sendMessage')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
                  </div>
                  {{ $t("odeslatZpravu") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleChangeGroupModal('addToGroups')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                  </div>
                  {{ $t("CHANGE_DATA_FLOW") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleChangeServiceModal('changeService')
                      isActionsDropdownVisible = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg" />
                  </div>
                  {{ $t("zmenitSluzbu") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleDeleteDevice(selectedRows)
                      isActionsDropdownVisible = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                  </div>
                  {{ $t("smazatZarizeni") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleMoveDeviceModal('moveDevice')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/icon_move_orange.svg" />
                  </div>
                  {{ $t("MOVE_DEVICE") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="exportDevices('xlsx')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/icon_xlsx.svg" />
                  </div>
                  {{ $t("LABEL_EXPORT_XLSX") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="exportDevices('csv')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/icon_csv.svg" />
                  </div>
                  {{ $t("LABEL_EXPORT_CSV") }}
                </div>
                <!--b-col cols="6" class="dropdown-actions__item d-flex align-items-center" @click="toggleSideBox(1)">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg">
                  </div>
                  {{ $t("zmenitSluzbu") }}
                </b-col-->
              </div>
            </div>
          </div>
        </div>

        <TableV2
          :columns="columns"
          table-id="lora"
          item-id="deviceId"
          :items="allDevices"
          :items-total-count="itemsCount"
          kebab
          selectable
          @page-change="
            (e) => {
              page = e
              reloadItems()
            }
          "
          @page-size-change="
            (e) => {
              rowsPerPage = e
              reloadItems()
            }
          "
          @sort-by="
            (e) => {
              sortBy = e.sortBy
              sortType = e.sortType
              reloadItems()
            }
          "
          @rows-selected="selectedRows = $event"
        >
          <template #custDeviceName="{ item }">
            <RouterLink
              :to="{
                name: 'device',
                params: {
                  id: item.deviceId,
                  device: item,
                  customerId: item.customerId,
                  projectId: item.projectId
                }
              }"
              class="font-weight-bolder link-gray"
              @click="navigateToDetail(item)"
            >
              <span style="display: block; word-wrap: break-word">
                {{ item.custDeviceName }}
              </span>
            </RouterLink>
          </template>

          <template #deviceId="{ item }">
            <div class="d-flex">
              <div v-tooltip :title="item.deviceId">
                <span class="eui-short">
                  {{ $filters.strLimitEnd(item.deviceId, 6) }}
                </span>
                <span class="eui-full">{{ item.deviceId }}</span>
              </div>
              <div class="ml-2 copy d-flex align-items-center" @click="copyToClipboard(item.deviceId)">
                <img src="@/assets/icons/actions/ico-ico-copy.svg" />
              </div>
            </div>
          </template>

          <template #status="{ item }">
            <DeviceStatusIcon :device="item" />
          </template>

          <template #deviceGroups="{ item }">
            <div
              v-for="group in item.deviceGroups.slice(0, 1)"
              :key="group.deviceGroupId + 'g' + item.deviceId"
              class="d-flex"
            >
              <RouterLink
                class="link-gray"
                :to="{
                  name: 'group',
                  params: {
                    id: group.deviceGroupId,
                    projectId: group.projectId,
                    customerId: this.$route.params.customerId
                  }
                }"
              >
                <span>
                  {{ $filters.strLimit(group.deviceGroupName, 25) }}
                </span>
              </RouterLink>
              <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                <span v-if="openedGroups.indexOf(item) > -1">-</span>
                <span v-else>+</span>
                {{ item.deviceGroups.length - 1 }}
              </div>
            </div>

            <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
              <div
                v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                :key="group.deviceGroupId + 'g' + item.device"
                class=""
              >
                <a
                  class="link-gray"
                  @click="
                    $router.push({
                      name: 'group',
                      params: {
                        id: group.deviceGroupId,
                        group: group
                      }
                    })
                  "
                >
                  <span>{{ group.deviceGroupName }}</span>
                </a>
              </div>
            </div>

            <div class="" />
          </template>

          <template #tags="{ item }">
            <TagBubbles :is-open="openedTags.includes(item)" :tag-list="item.tags" />
          </template>

          <template #batteryStatus="{ item }">
            <BatteryStatus :device="item" />
          </template>

          <template #signalStrength="{ item }">
            <SignalStrengthIcon :device="item" />
          </template>

          <template #lastMessageIn="{ item }">
            <span
              v-if="item.lastMessageIn != null"
              class="link"
              @click="
                () => {
                  toggleShowMessage('showMessage')
                  setMessageDeviceToShow(item)
                }
              "
            >
              {{ $t("pred") }}
              {{ $filters.beforeTime(item.lastMessageIn, "short") }}
            </span>
          </template>

          <template #deviceType="{ item }">
            {{ item.parameters ? item.parameters.devicetype : "" }}
          </template>

          <template #projectId="{ item }">
            {{ projectIdsAndNames[item.projectId] }}
          </template>

          <template #transformationLabel="{ item }">
            {{ item.transformationLabel || $t("noTransformFunction") }}
          </template>

          <template #provisionTime="{ item }">
            {{ new Date(item.provisionTime).toLocaleString() }}
          </template>

          <template #preregistrationEnd="{ item }">
            <span v-if="item.preregistrationEnd">
              {{ new Date(item.preregistrationEnd).toLocaleString() }}
            </span>
          </template>

          <template #kebab-actions="{ item }">
            <div
              class="dropdown-actions__item d-flex align-items-center"
              @click="
                () => {
                  actionItems = [item]
                  toggleEditDeviceModal('editDevice')
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
              </div>
              {{ $t("upravitZarizeni") }}
            </div>
            <div
              class="dropdown-actions__item d-flex align-items-center"
              cols="6"
              @click="
                () => {
                  actionItems = [item]
                  toggleChangeServiceModal('changeService')
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg" />
              </div>
              {{ $t("zmenitSluzbu") }}
            </div>
            <div
              class="dropdown-actions__item d-flex align-items-center"
              cols="6"
              @click="
                () => {
                  actionItems = [item]
                  toggleMoveDeviceModal('moveDevice')
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/icon_move_orange.svg" />
              </div>
              {{ $t("MOVE_DEVICE") }}
            </div>
            <div
              v-if="item.partnerId === 3"
              class="dropdown-actions__item d-flex align-items-center"
              cols="6"
              @click="
                () => {
                  actionItems = [item]
                  toggleSendMessageModal('sendMessage')
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
              </div>
              {{ $t("poslatZpravuNaZarizeni") }}
            </div>
            <div
              class="dropdown-actions__item d-flex align-items-center"
              cols="6"
              @click="
                () => {
                  actionItems = [item]
                  toggleDeleteDevice([item])
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
              </div>
              {{ $t("odstranitZarizeni") }}
            </div>
          </template>

          <template #customFooterActions>
            <p class="link-gray mb-0" style="margin-right: 10px" @click="showSidebarTableColumnOrder = true">
              <span>{{ $t("upravitSloupce") }}</span>
            </p>
            <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("rozbalitVsechnyRadky") }}</span>
            </p>
            <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("sbalitVsechnyRadky") }}</span>
            </p>
          </template>
        </TableV2>
      </div>
      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">{{ $t("nicKZobrazeni") }}.</div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>

    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("zarizeni") }}
          </h1>
        </div>
      </div>
    </div>

    <DeleteDeviceModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleDeleteDevice()"
      @yes="
        () => {
          deleteDevice()
          toggleDeleteDevice()
        }
      "
    />
    <AddToGroupsModal
      :devices="actionItems"
      :opened="openedAddToGroups"
      @close-box="toggleChangeGroupModal"
      @open-box="toggleChangeGroupModal"
      @reload-items="reloadItems()"
    />
    <SendMessageModal
      :devices="actionItems"
      :opened="openedSendMessage"
      @close-box="toggleSendMessageModal"
      @open-box="toggleSendMessageModal"
    />
    <AddTagsModal
      :devices="actionItems"
      :opened="openedAddTags"
      @close-box="toggleAddTagsModal"
      @open-box="toggleAddTagsModal"
    />
    <RemoveTagsModal
      :devices="actionItems"
      :opened="openedRemoveTags"
      @close-box="toggleRemoveTagsModal"
      @open-box="toggleRemoveTagsModal"
    />
    <ChangeStatusModal
      :devices="actionItems"
      :opened="openedChangeStatusModal"
      @close-box="toggleChangeStatusModal"
      @open-box="toggleChangeStatusModal"
    />
    <ChangeServiceModal
      v-if="actionItems[0]"
      :device="actionItems"
      :opened="openedChangeServiceModal"
      @close-box="toggleChangeServiceModal"
      @open-box="toggleChangeServiceModal"
    />
    <ShowMessage
      :device="deviceToShow"
      :item="messageToShow"
      :opened="openedMessageDetail"
      @close-box="toggleShowMessage"
    />
    <EditDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="actionItems[0]"
      :opened="openedEditDevice"
      :reload-attributes="reloadEditedDevice"
      :tags="tags"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @reload-items="reloadItems()"
    />
    <MoveDeviceModal
      v-if="openedMoveDevice.length > 0"
      :devices="actionItems"
      :opened="openedMoveDevice"
      @close-box="toggleMoveDeviceModal"
      @device-moved="reloadItems()"
      @open-box="toggleMoveDeviceModal"
    />
    <TableColumnOrder
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @close-box="closeSidebarTableColumnOrder()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>
<!-- push test -->

<script>
import _ from "lodash"
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import Paging from "@/components/paging/paging.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import AddToGroupsModal from "@/components/modals/devices/addToGroups.vue"
import SendMessageModal from "@/components/modals/devices/sendMessage.vue"
import AddTagsModal from "@/components/modals/devices/addTags.vue"
import RemoveTagsModal from "@/components/modals/devices/removeTags.vue"
import EditDeviceModal from "@/components/modals/devices/edit.vue"
import ChangeStatusModal from "@/components/modals/devices/changeStatus.vue"
import ChangeServiceModal from "@/components/modals/devices/changeService.vue"
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
import ShowMessage from "@/components/modals/devices/messageShow.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ExtendedSearch from "@/components/search/search-devices.vue"
import CopyNotification from "@/components/notify/notify.vue"
import SignalStrengthIcon from "@/components/boxes/signalStrengthIcon.vue"
import BatteryStatus from "@/components/boxes/batteryStatus.vue"
import AppLoader from "@/components/loader.vue"
import MoveDeviceModal from "@/components/modals/devices/move.vue"
import { exportDevices } from "@/plugins/exportDevices"
import DeviceListWarningBoxes from "@/components/devices/partials/ListWarningBoxes.vue"
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue"
import TagBubbles from "@/components/devices/tagBubbles.vue"
import ImportDeviceButton from "@/components/devices/partials/ImportDeviceButton.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useConfigStore } from "@/store/modules/config"
import { useLoraStore } from "@/store/modules/devices/lora"
import TableV2 from "@/components/custom-table/TableV2.vue"

export default {
  directives: {},
  components: {
    TableV2,
    ImportDeviceButton,
    DeviceStatusIcon,
    DeviceListWarningBoxes,
    SignalStrengthIcon,
    BatteryStatus,
    DeleteDeviceModal,
    EditDeviceModal,
    AddToGroupsModal,
    RadioHelp,
    RadioOpenClose,
    AddTagsModal,
    RemoveTagsModal,
    ChangeStatusModal,
    ChangeServiceModal,
    ShowMessage,
    SendMessageModal,
    ErrorModal,
    CopyNotification,
    TableColumnOrder,
    ExtendedSearch,
    AppLoader,
    MoveDeviceModal,
    TagBubbles
  },
  setup() {
    const authStore = useAuthStore()
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const configStore = useConfigStore()
    const loraStore = useLoraStore()

    return {
      authStore,
      projectStore,
      customerStore,
      configStore,
      loraStore
    }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      enabledExtendedSearch: false,
      tableWidth: 0,
      columns: [
        {
          title: "custDeviceName",
          name: "custDeviceName",
          sortable: true,
          minWidth: "250px"
        },
        {
          title: "status",
          name: "status",
          sortable: true,
          minWidth: "50px"
        },
        {
          title: "deviceId",
          name: "deviceId",
          sortable: true,
          minWidth: "180px"
        },
        {
          title: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          minWidth: "300px"
        },
        {
          title: "tags",
          name: "tags",
          sortable: false,
          minWidth: "150px"
        },
        {
          title: "bateryStatus",
          name: "batteryStatus",
          sortable: true,
          minWidth: "70px"
        },
        {
          title: "signalStrength",
          name: "signalStrength",
          sortable: true,
          minWidth: "80px"
        },
        {
          title: "lastMessageIn",
          name: "lastMessageIn",
          sortable: true,
          minWidth: "150px"
        },
        {
          title: "devicetype",
          name: "deviceType",
          sortable: true,
          minWidth: "100px"
        },
        {
          title: "LABEL_PROJECT_NAME",
          name: "projectId",
          sortable: false,
          minWidth: "210px"
        },
        {
          title: "custServiceId",
          name: "custServiceId",
          sortable: false,
          minWidth: "210px"
        },
        {
          title: "PROVISION_TIME_LABEL",
          name: "provisionTime",
          sortable: false,
          minWidth: "210px"
        }
      ],
      columnsTypeName: "columnsDevicesLora",
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      search: "",
      suggested: "",
      suggestionsArray: [],
      suggestionLoading: false,
      isActionsDropdownVisible: false,
      sort: "custDeviceName",
      rowsPerPage: 20,
      page: 0,
      selectedRows: [],
      projectIdsAndNames: [],
      selectedAll: false,
      openedSideBox: false,
      openedDevice: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      copyConfirmVisible: false,
      openedDeleteDevice: false,
      isSearchThroughAllProjects: false,
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      openedChangeStatusModal: [],
      openedChangeServiceModal: [],
      deleteText: "",
      openedMessageDetail: [],
      deviceToShow: {},
      messageToShow: {},
      tags: [],
      openedAddTags: [],
      openedRemoveTags: [],
      openedSendMessage: [],
      openedEditDevice: [],
      actionItems: [],
      reloadEditedDevice: false,
      sortBy: "custDeviceName",
      sortType: "asc",
      loaded: false,
      loadingData: true,
      errorsToTranslate: [],
      openedError: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      filterData: [],
      paramFilterData: [],
      isProjectOnLoad: false,
      openedMoveDevice: [],
      filterType: [
        {
          name: "DEVICE_NAME",
          type: "custDeviceName",
          arrayValue: []
        },
        {
          name: "DEVICE_STATUS_IS",
          type: "status",
          arrayValue: []
        },
        {
          name: "BATTERY_STATUS_IS",
          type: "bateryStatus",
          arrayValue: []
        },
        /** docasne skryto - cekame na upresneni zadani zda budeme brat ze signalStrength
         {
         name: "Síla signálu je",
         type: "signalStrength"
         },
         */
        {
          name: "ACTIVATION_TYPE_IS",
          type: "deviceType",
          arrayValue: []
        },
        /** docasne skryto - TODO
         {
         name: "Datum poslední zprávy",
         type: "lastMessageDate"
         },
         */
        {
          name: "IS_IN_GROUPS",
          type: "deviceGroupId",
          arrayValue: []
        },
        {
          name: "HAS_TAGS",
          type: "tags",
          arrayValue: []
        },
        {
          name: "SERVICE_IS",
          type: "custServiceId",
          arrayValue: []
        },
        {
          name: "DEV_EUI",
          type: "deviceId",
          arrayValue: []
        },
        {
          name: "LAST_MESSAGE_IN",
          type: "lastMessageIn",
          arrayValue: []
        }
      ]
    }
  },
  computed: {
    allDevices() {
      return [...this.loraStore.deviceList]
    },
    itemsCount() {
      return this.loraStore.totalCount ?? 0
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    },
    project() {
      return this.projectStore.selectedProject
    },
    allDevicesUnique() {
      let devices = this.allDevices
      let uniqed = _.uniqBy(devices, "deviceId")
      return uniqed
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    projects() {
      return this.projectStore.projectList
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    fullTextSearch() {
      const substrings = this.search.split("-")
      if (substrings.filter((str) => str.length).length > 1) {
        const transformedSubstrings = []
        for (const substring of substrings) {
          if (substring.length <= 2) {
            continue
          }

          transformedSubstrings.push(`+${substring}`)
        }

        return transformedSubstrings.join(" ")
      }
      return this.search.replace("-", "")
    },
    allItemsSelected() {
      const selectedIds = this.selectedRows.map((row) => row.deviceId)
      for (const device of this.allDevices) {
        if (!selectedIds.includes(device.deviceId)) {
          return false
        }
      }
      return true
    },
    tableColumnsDefault() {
      let rv = {}
      for (const [idx, col] of this.columns.entries()) {
        if (idx === 0) {
          continue
        }

        rv[col.name] = { ...col, order: idx + 1, show: true }
      }
      return rv
    }
  },
  watch: {
    search() {
      if (this.suggested === "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    suggested() {},
    project() {
      this.loadingData = true
      this.selectedRows = []

      if (!this.isProjectOnLoad) {
        this.loadDevices()
      }
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    if (localStorage.rowsPerPage) {
      this.rowsPerPage = localStorage.rowsPerPage
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }

    if (this.project) {
      this.loadDevices()
      this.isProjectOnLoad = true
    }

    this.tableColumns = this.getTableColumns()
  },
  methods: {
    searchThroughAllProjects() {
      this.isSearchThroughAllProjects = !this.isSearchThroughAllProjects
    },
    navigateToDetail(item) {
      let project = this.projects.find((i) => i.projectId == item.projectId)

      if (project.customerId !== this.customer.customerId) {
        let customer = this.customers.find((i) => i.customerId === project.customerId)
        this.customerStore.setCustomer(customer)
      }
      this.projectStore.setProject(project)

      this.$router.push({
        name: "device",
        params: {
          id: item.deviceId,
          device: item,
          customerId: item.customerId,
          projectId: item.projectId
        }
      })
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    toggleExtendedSearch() {
      this.enabledExtendedSearch = !this.enabledExtendedSearch
    },
    /**
     * load all lora devices with actual search, sort and paging parameters
     */
    async loadDevices() {
      this.loadingData = true
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }
      this.filterData = []

      if (this.isSearchThroughAllProjects) {
        const projectIdsAndNames = this.projects.reduce((result, project) => {
          result[project.projectId] = project.projectName
          return result
        }, {})

        this.projectIdsAndNames = projectIdsAndNames
      } else {
        this.filterData.push({
          field: "projectId",
          value: this.projectId
        })
        this.projectIdsAndNames[this.projectId] = this.project.projectName
      }
      if (this.paramFilterData.length) {
        let p = 0
        for (p = 0; p < this.paramFilterData.length; p++) {
          this.filterData.push({
            field: this.paramFilterData[p].name,
            value: this.paramFilterData[p].value,

            operator: this.paramFilterData[p].operator
          })
        }
      }
      const devices = await this.loraStore.getList({
        filters: this.filterData,
        search: this.fullTextSearch,
        sort: this.sortBy,
        sortType: this.sortType,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })
      if (devices) {
        this.loadingData = false
      }
    },
    reloadItems() {
      // this.selectedRows = [];
      this.loadDevices()
    },
    sortItemsBy(sortBy) {
      this.sortBy = sortBy
      if (this.sortType == "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
      this.sort = new String(sortBy)
      this.reloadItems()
    },
    searchLoraDevices() {
      this.loadingData = true
      // clear array
      this.suggestionsArray = []
      this.page = 0
      if (this.search.length < 1) {
        this.isSearchThroughAllProjects = false
      }
      this.reloadItems()
    },
    setFilterData(filterData) {
      this.paramFilterData = filterData
      this.page = 0

      this.reloadItems()
    },
    suggestions() {
      this.suggestionLoading = true
      let projectId = this.projectId
      let url =
        process.env.VUE_APP_API +
        "/lora/devices/suggestions?projectId[eq]=" +
        projectId +
        "&search=" +
        encodeURIComponent(this.fullTextSearch) +
        "*"
      if (this.isSearchThroughAllProjects) {
        url =
          process.env.VUE_APP_API +
          "/lora/devices/suggestions" +
          "?search=" +
          encodeURIComponent(this.fullTextSearch) +
          "*"
      }

      axios
        .get(url, {})
        .then((response) => {
          this.suggestionsArray = response.data.data
          this.suggestionLoading = false
        })
        .catch(() => {
          this.suggestionLoading = false
        })
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchLoraDevices()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.isSearchThroughAllProjects = false
      this.searchLoraDevices()
      this.suggestionsArray = []
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = this.isActionsDropdownVisible ? false : true
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.deviceId === device.deviceId).length > 0) {
        const index = this.selectedRows.map((e) => e.deviceId).indexOf(device.deviceId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    selectAll(type) {
      if (type === "deselect") {
        this.selectedRows = []
        return
      }

      if (this.allItemsSelected) {
        const visibleDeviceIds = this.allDevices.map((device) => device.deviceId)
        this.selectedRows = this.selectedRows.filter((row) => !visibleDeviceIds.includes(row.deviceId))
      } else {
        this.selectedRows = this.selectedRows.concat(this.allDevices)
      }
    },
    openKebab(device) {
      this.openedDevice = this.openedDevice == device ? {} : device
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat(this.allDevices)
        this.openedGroups = [].concat(this.allDevices)
        this.toggledAllRows = true
      }
    },
    toggleDeleteDevice(items) {
      if (this.openedDeleteDevice == true) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    async deleteDevice() {
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      let notifications = []
      let er = [{ errors: [] }]
      for (const item of this.actionItems) {
        try {
          await this.loraStore.deleteDevice(item)
          notifications.push({
            text: "notificationDeviceDelete",
            error: false,
            params: {
              deviceId: item.deviceId,
              custDeviceName: item.custDeviceName
            }
          })
        } catch (e) {
          let message = e.data.errors?.[0]
          er[0].errors.push({
            message: message,
            attribute: {
              deviceId: item.deviceId,
              custDeviceName: item.custDeviceName
            }
          })
        }
      }
      if (er[0].errors.length) {
        this.errorsToTranslate = er
        this.openedError = true
      }
      this.$store.commit("modals/setWaitingLoader", "")
      this.$store.commit("modals/setGlobalNotification", notifications)
      this.selectedRows = []
      this.allDevices = []
      this.loadDevices()
    },
    toggleChangeGroupModal(box) {
      if (this.openedAddToGroups.indexOf(box) > -1) {
        box === undefined
          ? (this.openedAddToGroups = [])
          : (this.openedAddToGroups = this.openedAddToGroups.filter((item) => item !== box))
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddToGroups = this.openedAddToGroups.concat([box])
      }
    },
    toggleSendMessageModal(box) {
      if (box === undefined || this.openedSendMessage.indexOf(box) > -1) {
        box === undefined
          ? (this.openedSendMessage = [])
          : (this.openedSendMessage = this.openedSendMessage.filter((item) => item !== box))
        this.isActionsDropdownVisible = false
      } else {
        this.openedSendMessage = this.openedSendMessage.concat([box])
      }
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box === undefined
          ? (this.openedEditDevice = [])
          : (this.openedEditDevice = this.openedEditDevice.filter((item) => item !== box))

        this.selectedRows = []
        this.selectedAll = false
        if (box === undefined || box === "editDevice") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditDevice.push(box)
        if (box === "editDevice") {
          this.reloadEditedDevice = true
          setTimeout(() => {
            this.reloadEditedDevice = false
          }, 1500)
        }
      }
    },
    toggleAddTagsModal(box) {
      if (box === undefined || this.openedAddTags.indexOf(box) > -1) {
        box === undefined
          ? (this.openedAddTags = [])
          : (this.openedAddTags = this.openedAddTags.filter((item) => item !== box))
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddTags = this.openedAddTags.concat([box])
      }
    },
    toggleRemoveTagsModal(box) {
      if (box === undefined || this.openedRemoveTags.indexOf(box) > -1) {
        box === undefined
          ? (this.openedRemoveTags = [])
          : (this.openedRemoveTags = this.openedRemoveTags.filter((item) => item !== box))
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveTags = this.openedRemoveTags.concat([box])
      }
    },
    toggleChangeStatusModal(box) {
      if (box == undefined || this.openedChangeStatusModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedChangeStatusModal = [])
          : (this.openedChangeStatusModal = this.openedChangeStatusModal.filter((item) => item !== box))
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeStatusModal = this.openedChangeStatusModal.concat([box])
      }
    },
    toggleChangeServiceModal(box) {
      if (box == undefined || this.openedChangeServiceModal.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedChangeServiceModal = []
          this.loadDevices()
        } else {
          this.openedChangeServiceModal = this.openedChangeServiceModal.filter((item) => item !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeServiceModal = this.openedChangeServiceModal.concat([box])
      }
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : (this.openedMessageDetail = this.openedMessageDetail.filter((item) => item !== box))
      } else {
        this.openedMessageDetail = this.openedMessageDetail.concat([box])
      }
    },
    setMessageDeviceToShow(device) {
      axios
        .get(
          process.env.VUE_APP_API +
            "/lora/devices/" +
            device.deviceId +
            "/up/messages?from=" +
            device.lastMessageIn +
            "&to=" +
            device.lastMessageIn +
            "&limit=1000",
          {}
        )
        .then((result) => {
          const length = result.data.data.length
          let message = result.data.data[length - 1]
          message.type = "up"
          let gws = message.message.gws
          if (gws != null) {
            let sortedBySnr = _.orderBy(gws, "snr", "desc")
            let largestSnr = sortedBySnr[0].snr
            message.snr = largestSnr
            let sortedByRssi = _.orderBy(gws, "rssi", "desc")
            let largestRssi = sortedByRssi[0].rssi
            message.rssi = largestRssi
          }

          this.messageToShow = message
          this.deviceToShow = device
        })
        .catch(() => {})
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeKebab() {
      this.openedDevice = {}
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$updateTableContent(this)
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (
        Object.keys(localStorageItems).length === 0 ||
        Object.keys(localStorageItems).length !== Object.keys(this.tableColumnsDefault).length
      ) {
        return this.tableColumnsDefault
      }

      return localStorageItems
    },
    async exportDevices(type) {
      this.errorsToTranslate = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))
      const errors = await exportDevices(
        type,
        "lora",
        this.projectId,
        this.selectedRows.map((device) => device.deviceId)
      )
      this.$store.commit("modals/setWaitingLoader", "")
      if (errors?.length) {
        this.errorsToTranslate = errors
        this.openedError = true
      }
    },
    toggleMoveDeviceModal(box) {
      if (this.openedMoveDevice.indexOf(box) > -1) {
        box === undefined
          ? (this.openedMoveDevice = [])
          : this.openedMoveDevice.splice(this.openedMoveDevice.indexOf(box), 1)
      } else {
        this.openedMoveDevice.push(box)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.extended-search__toggle.open img {
  transform: rotate(-180deg);
}

.eui-short {
  display: none;
}

.eui-full {
  display: block;
}

/*
.shadowed .eui-short {
  display: block;
}

.shadowed .eui-full {
  display: none;
}
*/
</style>
